import { useContext } from 'react';

import { DocumentSettingsContext } from 'components/editor/SidePanel/DocumentSettings/DocumentDesignSettings/DocumentSettingsContext';
import { FeatureFlags } from 'utils/featureFlags';
import type { PageOrientation } from 'components/editor/shared/gridConfig';
import useFeatureFlag from './useFeatureFlag';
import { selectContentType } from '../components/editor/grid/reduxStore/documentSettingsSlice';
import { useAppSelector } from '../components/editor/grid/reduxStore/Store';
import { ContentType } from 'utils/getContentType';

// Single source of truth for the page-orientation-settings gate.
// All orientation-dependent consumers (CSS canvas width, drag snap, clip bounds, etc.)
// must call this hook rather than reading documentSettings.pageOrientation directly.
export function useEffectiveOrientation(): PageOrientation {
  const { documentSettings, sectionStyles } = useContext(DocumentSettingsContext);
  const flags = useFeatureFlag([FeatureFlags.pageOrientationSettings]);
  const isFlagEnabled = flags[FeatureFlags.pageOrientationSettings];
  const contentType = useAppSelector(selectContentType);

  // !isFlagEnabled intentionally covers both false (off) and undefined (still loading).
  if (!isFlagEnabled) return 'portrait';
  if (contentType === ContentType.SECTION) return sectionStyles.pageOrientation ?? 'portrait';
  return documentSettings.pageOrientation ?? 'portrait';
}
